'use client';

import { Suspense, useCallback, useState } from 'react';

import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.js';
import { ArticleTypesEnum } from '@sola/contentful-model/lib/taxonomy-values.js';

import { ArticleFilter } from './article-filter';
import { ArticleList } from './article-list';

const ArticleFilterSkeleton = () => (
  <div className="ArticleFilter">
    <div className="ArticleFilter__container flex flex-col md:flex-row md:justify-between md:align-center gap-comfy-lg">
      <div className="body-md md:align-center">
        <Skeleton height={20} width={120} />
      </div>
      <div className="flex align-end md:justify-end md:align-center gap-comfy-sm">
        <Skeleton height={40} width={140} borderRadius="0.5rem" />
        <Skeleton height={40} width={80} borderRadius="0.5rem" />
      </div>
    </div>
  </div>
);

type ArticleControlsProps = {
  seoLevel?: number;
  articleType?: ArticleTypesEnum;
  topic?: string;
  country?: string;
  theme?: string;
  limit?: number;
};

export const ArticleControls = ({
  seoLevel,
  articleType,
  topic,
  country,
  theme,
  limit,
}: ArticleControlsProps) => {
  const [articleCount, setArticleCount] = useState<number | undefined>(
    undefined,
  );

  const onArticleLoad = useCallback(
    ({ totalCount }: { totalCount: number }) => {
      setArticleCount(totalCount);
    },
    [],
  );

  const articleFilterCount =
    topic || country || theme ? articleCount : undefined;

  return (
    <div className="grid gap-comfy-xl md:gap-roomy-sm">
      <Suspense fallback={<ArticleFilterSkeleton />}>
        <ArticleFilter articleCount={articleFilterCount} limit={limit} />
      </Suspense>
      <ArticleList
        seoLevel={seoLevel}
        articleType={articleType}
        topic={topic}
        country={country}
        theme={theme}
        limit={limit}
        onArticleLoad={onArticleLoad}
      />
    </div>
  );
};
